<script setup>
defineProps({
  status: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: 'm',
  },
})
</script>

<template>
  <div
    :class="{
      [$style.dot]: true,
      [$style[size]]: size,
      [$style[status]]: !!status,
    }"
  />
</template>

<style module>
.dot {
  border-radius: 50%;
  background-color: var(--color-elements);

  /* Sizes */
  &.s {
    height: 10px;
    width: 10px;
  }
  &.m {
    height: 16px;
    width: 16px;
  }
  &.l {
    height: 24px;
    width: 24px;
  }

  /* Colors */
  &.success {
    background-color: var(--color-status-success);
  }
  &.warning {
    background-color: var(--color-status-warning);
  }
  &.danger {
    background-color: var(--color-status-danger);
  }
  &.info {
    background-color: var(--color-status-info);
  }
}
</style>
